import { render, staticRenderFns } from "./GlobeIcon.vue?vue&type=template&id=dcb38ce8&scoped=true"
import script from "./GlobeIcon.vue?vue&type=script&lang=js"
export * from "./GlobeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb38ce8",
  null
  
)

export default component.exports